import { useAuthParticipent } from "@/store/authParticipants";

export default defineNuxtRouteMiddleware(async (to, from) => {
  return navigateTo("/login");
});
